import { DSNotificationEvent } from '@cims-online/shared'
import CIMSNotifications from 'components/CIMSNotifications'
import RecipientsSelectProvider from 'components/CIMSSelect/common/RecipientsSelect/RecipientsSelectContext'
import DSNotificationsProvider, {
  useDSNotificationsContext,
} from './DSNotificationsContext'
import DSNotificationDetails from './components/DSNotificationDetails'
import { useEditFn } from './hooks/useEdit'
import ViewDSNotificationEvent from './components/ViewDSNotificationEvent'

const InnerNotifications: React.FC = () => {
  const { refetch, fetching } = useDSNotificationsContext()
  const editFn = useEditFn()
  return (
    <CIMSNotifications
      onReload={refetch}
      loading={fetching}
      details={<DSNotificationDetails />}
      events={DSNotificationEvent.values}
      view={<ViewDSNotificationEvent />}
      edit={editFn}
    />
  )
}

export const Notifications: React.FC = () => (
  <RecipientsSelectProvider>
    <DSNotificationsProvider>
      <InnerNotifications />
    </DSNotificationsProvider>
  </RecipientsSelectProvider>
)

export default Notifications
